var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-icon"},[(!_vm.loading)?_c('i',{class:_vm.symbol}):_c('v-loader',{attrs:{"size":"md","type":"white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }